import { Injectable } from '@angular/core';
import { DocumentDto } from '@fleet-beat/core';
import { BaseEditorService, EditorContainerConfig, EditorFieldType, EditorHelperService } from '@fleet-beat/editor';
import { AddDocumentFormModel } from '../models/add-document-dialog-form.model';
import { CompanyStoreService } from '@fleet-beat/shared';
import * as moment from 'moment';

@Injectable()
export class AddDocumentDialogEditorService extends BaseEditorService<DocumentDto, AddDocumentFormModel, DocumentDto> {
  override get config(): EditorContainerConfig<DocumentDto, AddDocumentFormModel, DocumentDto> {
    return {
      editor: {
        readonly: false,
        items: [
          {
            name: 'title',
            label: 'Document name',
            type: EditorFieldType.STRING,
            width: '100%',
            required: true,
          },
          {
            name: 'documentId',
            placeholder: 'Document ID',
            label: 'Document ID',
            type: EditorFieldType.STRING,
            width: '100%',
          },
          {
            name: 'expirationDate',
            placeholder: 'Expiration date',
            label: 'Expiration date',
            type: EditorFieldType.DATE,
            width: '100%',
          },
          {
            name: 'description',
            label: 'Enter document description',
            type: EditorFieldType.TEXT_AREA,
            width: '100%',
            required: false,
            maxLength: 200,
          },
          {
            name: 'file',
            type: EditorFieldType.FILE,
            withLogo: false,
            width: '100%',
            required: true,
          },
        ],
      },
      convertToOutput: (form: AddDocumentFormModel) => this.convertToOutput(form),
    };
  }

  constructor(
    protected override editorHelperService: EditorHelperService,
    private companyStoreService: CompanyStoreService,
  ) {
    super(editorHelperService);
  }

  override convertToForm(data: DocumentDto): AddDocumentFormModel {
    return data;
  }

  protected override convertToOutput(form: AddDocumentFormModel): DocumentDto {
    return {
      ...form,
      expirationDate: form.expirationDate
        ? moment.tz(moment(form.expirationDate).format('YYYY-MM-DD'), this.companyStoreService.timezone).format()
        : null,
    };
  }
}
